import { CertificateInterface } from "../../../common/interfaces/CertificateInterface";
import { PostActionType, Refetch } from "../../../common/types/Types";
import { toast } from "react-toastify";
import {
    setAcceptIsLoading,
    setCurrentProcessingId,
    setIsReviewCertificateSuccess,
} from "../ReviewSlice";
import { Dispatch } from "redux";
import {
    setFormValues,
    setIsRejectCertificateModalOpen,
} from "../../../modals/RejectCertificateModal/RejectCertificateModalSlice";

interface HandleReviewProps {
    certificate: CertificateInterface;
    patchCertificate: PostActionType;
    refetch: Refetch;
    comment?: string;
    review: boolean;
    dispatch: Dispatch;
}

export const handleReview = async (props: HandleReviewProps): Promise<void> => {
    const {
        certificate,
        patchCertificate,
        refetch,
        comment,
        review,
        dispatch,
    } = props;

    dispatch(setCurrentProcessingId(certificate.id));

    if (review) {
        dispatch(setAcceptIsLoading(true));
    }

    try {
        await patchCertificate({
            id: certificate.id,
            data: {
                qualification_id: certificate.qualification.id,
                employee_id: certificate.employee.id,
                valid_at: certificate.valid_at,
                educator_id: certificate.educator.id,
                approved: review,
                comment: comment ?? null,
            },
        }).unwrap();
        refetch();

        dispatch(setAcceptIsLoading(false));
        dispatch(setIsReviewCertificateSuccess(true));

        if (review) {
            toast.success("Certificaat goedgekeurd");
            return;
        }

        dispatch(setFormValues(null));
        dispatch(setIsRejectCertificateModalOpen(false));
        toast.success("Certificaat afgekeurd");
    } catch (error) {
        console.error("Failed to handle certificate:", error);
    }
};
